import React, { useState, useEffect } from "react";
import { withApollo } from "react-apollo";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import { CVD_COMPARISON_LIST, CVD_PRODUCTS_LIST, CVD_PRODUCT_DETAILS } from "../../graphql/query";
import gql from "graphql-tag";
import axios from "axios";
import { API_URL, CVD_URL } from "../../config";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";

const UPDATE_CVD = gql`
  mutation UpdateDiamondComparison($tagNo: String!, $input: DiamondComparisonPatch!) {
    updateDiamondComparisonByTagNo(input: { tagNo: $tagNo, diamondComparisonPatch: $input }) {
      diamondComparison {
        tagNo
      }
    }
  }
`;

const DELETE_CVD = gql`
  mutation DeleteDiamondComparison($tagNo: String!) {
    deleteDiamondComparisonByTagNo(input: { tagNo: $tagNo }) {
      diamondComparison {
        tagNo
      }
    }
  }
`;

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    tableLayout: "fixed",
    width: "100%",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
  },
  search: {
    padding: "20px",
  },
  searchField: {
    width: "300px",
  },
  tableContainer: {
    width: "100%",
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5',
    },
    '&:hover': {
      backgroundColor: '#e3f2fd',
    },
  },
  tableHead: {
    backgroundColor: '#1976d2',
    '& .MuiTableCell-head': {
      color: 'white',
      fontWeight: 'bold',
    },
    '& .MuiTableSortLabel-root': {
      color: 'white !important',
    },
    '& .MuiTableSortLabel-icon': {
      color: 'white !important',
    },
  },

});

export const CVDTable = withApollo((props) => {
  const classes = useStyles();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("tagNo");
  const [order, setOrder] = useState("asc");
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteTagNo, setDeleteTagNo] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [messageDialog, setMessageDialog] = useState({ open: false, message: "", type: "" });
  const [imageDialog, setImageDialog] = useState({ open: false, tagNo: null, images: {} });
  const [imageDeleteDialog, setImageDeleteDialog] = useState({ open: false, imageNumber: null });
  const [importing, setImporting] = useState(false);
  const [cvdProducts, setCvdProducts] = useState([]);
  const [addDialog, setAddDialog] = useState(false);
  const [addData, setAddData] = useState({});
  const [priceSyncDialog, setPriceSyncDialog] = useState(false);
  const [priceSyncLoading, setPriceSyncLoading] = useState(false);
  const [historyDialog, setHistoryDialog] = useState(false);
  const [historyLogs, setHistoryLogs] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyDetailDialog, setHistoryDetailDialog] = useState({ open: false, log: null });
  const [priceSyncFilter, setPriceSyncFilter] = useState({ priceMin: "", priceMax: "", purities: [], productTypes: [] });

  const [priceSyncData, setPriceSyncData] = useState({
    labDiamondPrice: "",
    gstPercentage: "3",
    goldPrice24K: "",
    goldPrice22K: "",
    goldPrice18K: "",
    goldPrice14K: "",
    goldPrice9K: "",
    goldCostPrice24K: "",
    goldCostPrice22K: "",
    goldCostPrice18K: "",
    goldCostPrice14K: "",
    goldCostPrice9K: "",
    addOnPercentage: "5",
  });
  const [visibleColumns, setVisibleColumns] = useState({
    tagNo: true,
    name: true,
    naturalDiamondMetalWeight: false,
    naturalDiamondPurity: false,
    naturalDiamondMetalValue: false,
    naturalDiamondDiamondType: false,
    naturalDiamondNoOfDiamonds: false,
    naturalDiamondDiamondCarat: false,
    naturalDiamondDiamondPrice: false,
    naturalDiamondCertificate: false,
    naturalDiamondTotalPrice: false,
    metalWeight: true,
    purity: true,
    metalValue: true,
    diamondType: true,
    noOfDiamonds: true,
    diamondCarat: true,
    diamondPrice: true,
    certificate: true,
    totalPrice: true,
    totalSaved: true,
    diamondInProductValue: true,
    makingCharge: true,
    gstPercentage: true,
    gstValue: true,
    metalPrice: true,
    addOnPercentage: true,
  });

  const columns = [
    { key: "tagNo", label: "Tag No" },
    { key: "name", label: "Name" },
    { key: "naturalDiamondMetalWeight", label: "ND Metal Weight" },
    { key: "naturalDiamondPurity", label: "ND Purity" },
    { key: "naturalDiamondMetalValue", label: "ND Metal Value" },
    { key: "naturalDiamondDiamondType", label: "ND Diamond Type" },
    { key: "naturalDiamondNoOfDiamonds", label: "ND No of Diamonds" },
    { key: "naturalDiamondDiamondCarat", label: "ND Diamond Carat" },
    { key: "naturalDiamondDiamondPrice", label: "ND Diamond Price" },
    { key: "naturalDiamondCertificate", label: "ND Certificate" },
    { key: "naturalDiamondTotalPrice", label: "ND Total Price" },
    { key: "metalWeight", label: "Metal Weight" },
    { key: "purity", label: "Purity" },
    { key: "metalValue", label: "Metal Value" },
    { key: "diamondType", label: "Diamond Type" },
    { key: "noOfDiamonds", label: "No of Diamonds" },
    { key: "diamondCarat", label: "Diamond Carat" },
    { key: "diamondPrice", label: "Diamond Price (per carat)" },
    { key: "certificate", label: "Certificate" },
    { key: "totalPrice", label: "Total Price" },
    { key: "totalSaved", label: "Total Saved" },
    { key: "diamondInProductValue", label: "Diamond In Product Value" },
    { key: "makingCharge", label: "Making Charge" },
    { key: "gstPercentage", label: "GST%" },
    { key: "gstValue", label: "GST Value" },
    { key: "metalPrice", label: "Metal Price" },
    { key: "addOnPercentage", label: "Add On%" },
  ];

  useEffect(() => {
    fetchData();
    fetchCvdProducts();
  }, [props.filterparams]);

  const fetchCvdProducts = async () => {
    try {
      const result = await props.client.query({
        query: CVD_PRODUCTS_LIST,
        fetchPolicy: "network-only",
      });
      setCvdProducts(result.data.allProductLists.nodes);
    } catch (error) {
      console.error("Error fetching CVD products:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await props.client.query({
        query: CVD_COMPARISON_LIST,
        fetchPolicy: "network-only",
      });
      setData(result.data.allDiamondComparisons.nodes);
    } catch (error) {
      console.error("Error fetching CVD data:", error);
    }
    setLoading(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = data.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase())
    )
  );

  const sortedData = filteredData.sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] > b[orderBy] ? 1 : -1;
    }
    return a[orderBy] < b[orderBy] ? 1 : -1;
  });

  if (loading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  const handleColumnsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColumnsClose = () => {
    setAnchorEl(null);
  };

  const handleColumnToggle = (columnKey) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnKey]: !visibleColumns[columnKey],
    });
  };

  const handleEditClick = (row) => {
    setEditingRow(row.tagNo);
    setEditData(row);
  };

  const handleEditChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  const handleSaveEdit = async () => {
    try {
      if (editData.tagNo !== editingRow) {
        const exists = data.some(row => row.tagNo === editData.tagNo && row.tagNo !== editingRow);
        if (exists) {
          setMessageDialog({ open: true, message: "Tag No already exists. Please use a different Tag No.", type: "error" });
          return;
        }
      }
      const { tagNo, __typename, createdat, updatedat, ...updateFields } = editData;
      const input = updateFields;
      await props.client.mutate({
        mutation: UPDATE_CVD,
        variables: {
          tagNo: editingRow,
          input
        }
      });
      setData(data.map(row => row.tagNo === editingRow ? editData : row));
      setEditingRow(null);
      setEditData({});
      setMessageDialog({ open: true, message: "Record updated successfully", type: "success" });
    } catch (error) {
      console.error("Error updating CVD data:", error);
      setMessageDialog({ open: true, message: "Failed to save changes", type: "error" });
    }
  };

  const handleCancelEdit = () => {
    setEditingRow(null);
    setEditData({});
  };

  const handleDeleteClick = (tagNo) => {
    setDeleteTagNo(tagNo);
    setDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const recordToDelete = data.find(row => row.tagNo === deleteTagNo);
      
      // Delete S3 images first if they exist
      if (recordToDelete?.imageUrl1) {
        await fetch(`${API_URL}/cvd/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            tagNo: deleteTagNo,
            imageNumber: "1"
          })
        });
      }
      
      if (recordToDelete?.imageUrl2) {
        await fetch(`${API_URL}/cvd/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            tagNo: deleteTagNo,
            imageNumber: "2"
          })
        });
      }
      
      // Then delete database record
      await props.client.mutate({
        mutation: DELETE_CVD,
        variables: { tagNo: deleteTagNo }
      });
      
      setData(data.filter(row => row.tagNo !== deleteTagNo));
      setMessageDialog({ open: true, message: "Record deleted successfully", type: "success" });
    } catch (error) {
      console.error("Error deleting CVD data:", error);
      setMessageDialog({ open: true, message: "Failed to delete record", type: "error" });
    }
    setDeleteDialog(false);
    setDeleteTagNo(null);
  };

  const handleDeleteCancel = () => {
    setDeleteDialog(false);
    setDeleteTagNo(null);
  };

  const handleImageClick = (row) => {
    setImageDialog({ 
      open: true, 
      tagNo: row.tagNo,
      images: {
        image1: row.imageUrl1 || null,
        image2: row.imageUrl2 || null
      }
    });
  };

  const handleImageClose = () => {
    setImageDialog({ open: false, tagNo: null, images: {} });
  };

  const handleImageUpload = async (e, imageNumber) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('tagNo', imageDialog.tagNo);
      formData.append('imageNumber', imageNumber.toString());

      const response = await fetch(`${API_URL}/cvd/add`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      if (result.success) {
        const fieldName = imageNumber === 1 ? 'imageUrl1' : 'imageUrl2';
        
        await props.client.mutate({
          mutation: UPDATE_CVD,
          variables: {
            tagNo: imageDialog.tagNo,
            input: { [fieldName]: result.key }
          }
        });

        setImageDialog({
          ...imageDialog,
          images: {
            ...imageDialog.images,
            [`image${imageNumber}`]: result.key
          }
        });

        setData(data.map(row => 
          row.tagNo === imageDialog.tagNo 
            ? { ...row, [fieldName]: result.key } 
            : row
        ));

        setMessageDialog({ 
          open: true, 
          message: `Image ${imageNumber} uploaded successfully`, 
          type: "success" 
        });
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setMessageDialog({ open: true, message: "Failed to upload image", type: "error" });
    }
  };

  const handleImageDeleteClick = (imageNumber) => {
    setImageDeleteDialog({ open: true, imageNumber });
  };

  const handleImageDeleteConfirm = async () => {
    try {
      const tagNo = imageDialog.tagNo;
      const imageNumber = imageDeleteDialog.imageNumber;
      const fieldName = imageNumber === 1 ? 'imageUrl1' : 'imageUrl2';
      const imageKey = imageDialog.images[`image${imageNumber}`];

      if (!imageKey) {
        setMessageDialog({ open: true, message: "No image to delete", type: "error" });
        return;
      }

      const response = await fetch(`${API_URL}/cvd/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          key: imageKey
        })
      });

      const result = await response.json();
      
      if (!response.ok || !result.success) {
        console.error('Delete API Error:', result);
        throw new Error(result.message || `HTTP ${response.status}: ${response.statusText}`);
      }
      
      if (result.success) {
        await props.client.mutate({
          mutation: UPDATE_CVD,
          variables: {
            tagNo,
            input: { [fieldName]: null }
          }
        });

        setImageDialog({
          ...imageDialog,
          images: {
            ...imageDialog.images,
            [`image${imageNumber}`]: null
          }
        });

        setData(data.map(row => 
          row.tagNo === tagNo 
            ? { ...row, [fieldName]: null } 
            : row
        ));

        setMessageDialog({ 
          open: true, 
          message: `Image ${imageNumber} deleted successfully`, 
          type: "success" 
        });
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      setMessageDialog({ open: true, message: "Failed to delete image", type: "error" });
    }
    setImageDeleteDialog({ open: false, imageNumber: null });
  };

  const handleImageDeleteCancel = () => {
    setImageDeleteDialog({ open: false, imageNumber: null });
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImporting(true);
    const reader = new FileReader();
    
    reader.onload = async (event) => {
      try {
        let jsonData;
        if (file.name.endsWith('.csv')) {
          const csvText = event.target.result;
          const workbook = XLSX.read(csvText, { type: "string" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          jsonData = XLSX.utils.sheet_to_json(sheet);
        } else {
          const workbook = XLSX.read(event.target.result, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          jsonData = XLSX.utils.sheet_to_json(sheet);
        }

        const processedTagNos = new Set();
        
        for (const row of jsonData) {
          const tagNo = row["tag_no"] || row["Tag No"] || row["tagNo"];
          
          if (!tagNo) {
            console.error("Missing Tag No for row:", row);
            continue;
          }

          const exists = data.some(d => d.tagNo === tagNo) || processedTagNos.has(tagNo);
          processedTagNos.add(tagNo);

          const input = {};
          if (row["name"]) input.name = String(row["name"]);
          if (row["natural_diamond_metal_weight"]) input.naturalDiamondMetalWeight = String(row["natural_diamond_metal_weight"]);
          if (row["natural_diamond_purity"]) input.naturalDiamondPurity = String(row["natural_diamond_purity"]);
          if (row["natural_diamond_metal_value"]) input.naturalDiamondMetalValue = String(row["natural_diamond_metal_value"]);
          if (row["natural_diamond_diamond_type"]) input.naturalDiamondDiamondType = String(row["natural_diamond_diamond_type"]);
          if (row["natural_diamond_no_of_diamonds"]) input.naturalDiamondNoOfDiamonds = String(row["natural_diamond_no_of_diamonds"]);
          if (row["LGNECG00027_diamond_carat"] || row["natural_diamond_diamond_carat"]) input.naturalDiamondDiamondCarat = String(row["LGNECG00027_diamond_carat"] || row["natural_diamond_diamond_carat"]);
          if (row["natural_diamond_diamond_price"]) input.naturalDiamondDiamondPrice = String(row["natural_diamond_diamond_price"]);
          if (row["natural_diamond_certificate"]) input.naturalDiamondCertificate = String(row["natural_diamond_certificate"]);
          if (row["natural_diamond_total_price"]) input.naturalDiamondTotalPrice = String(row["natural_diamond_total_price"]);
          if (row["metal_weight"]) input.metalWeight = String(row["metal_weight"]);
          if (row["purity"]) input.purity = String(row["purity"]);
          if (row["metal_value"]) input.metalValue = String(row["metal_value"]);
          if (row["diamond_type"]) input.diamondType = String(row["diamond_type"]);
          if (row["no_of_diamonds"]) input.noOfDiamonds = String(row["no_of_diamonds"]);
          if (row["diamond_carat"]) input.diamondCarat = String(row["diamond_carat"]);
          if (row["diamond_price"]) input.diamondPrice = String(row["diamond_price"]);
          if (row["certificate"]) input.certificate = String(row["certificate"]);
          if (row["total_price"]) input.totalPrice = String(row["total_price"]);
          if (row["total_saved"]) input.totalSaved = String(row["total_saved"]);
          if (row["diamond_in_product_value"]) input.diamondInProductValue = String(row["diamond_in_product_value"]);
          if (row["making_charge"]) input.makingCharge = String(row["making_charge"]);
          if (row["gst_percentage"]) input.gstPercentage = String(row["gst_percentage"]);
          if (row["gst_value"]) input.gstValue = String(row["gst_value"]);
          if (row["metal_price"]) input.metalPrice = String(row["metal_price"]);
          if (row["add_on_percentage"]) input.addOnPercentage = String(row["add_on_percentage"]);

          // Auto-calculate derived values
          const diamondCarat = parseFloat(input.diamondCarat) || 0;
          const diamondPrice = parseFloat(input.diamondPrice) || 0;
          const metalValue = parseFloat(input.metalValue) || 0;
          const metalWeight = parseFloat(input.metalWeight) || 0;
          const makingCharge = parseFloat(input.makingCharge) || 0;
          const gstPercentage = parseFloat(input.gstPercentage) || 0;
          const addOnPercentage = parseFloat(input.addOnPercentage) || 0;
          const ndTotalPrice = parseFloat(input.naturalDiamondTotalPrice) || 0;

          const diamondInProductValue = Math.round(diamondCarat * diamondPrice);
          const metalPriceCalc = Math.round(metalValue * metalWeight);
          const gstValue = Math.round((gstPercentage / 100) * (diamondInProductValue + makingCharge + metalPriceCalc));
          const totalPrice = Math.round((diamondInProductValue + makingCharge + metalPriceCalc + gstValue) * (1 + addOnPercentage / 100));
          const totalSaved = Math.round(ndTotalPrice - totalPrice);

          input.diamondInProductValue = String(diamondInProductValue);
          input.metalPrice = String(metalPriceCalc);
          input.gstValue = String(gstValue);
          input.totalPrice = String(totalPrice);
          input.totalSaved = String(totalSaved);

          if (exists) {
            await props.client.mutate({
              mutation: UPDATE_CVD,
              variables: { tagNo, input }
            });
          } else {
            await props.client.mutate({
              mutation: gql`
                mutation CreateDiamondComparison(
                $tagNo: String!
                $name: String
                $naturalDiamondMetalWeight: String
                $naturalDiamondPurity: String
                $naturalDiamondMetalValue: String
                $naturalDiamondDiamondType: String
                $naturalDiamondNoOfDiamonds: String
                $naturalDiamondDiamondCarat: String
                $naturalDiamondDiamondPrice: String
                $naturalDiamondCertificate: String
                $naturalDiamondTotalPrice: String
                $metalWeight: String
                $purity: String
                $metalValue: String
                $diamondType: String
                $noOfDiamonds: String
                $diamondCarat: String
                $diamondPrice: String
                $certificate: String
                $totalPrice: String
                $totalSaved: String
                $diamondInProductValue: String
                $makingCharge: String
                $gstPercentage: String
                $gstValue: String
                $metalPrice: String
                $addOnPercentage: String
              ) {
                createDiamondComparison(
                  input: {
                    diamondComparison: {
                      tagNo: $tagNo
                      name: $name
                      naturalDiamondMetalWeight: $naturalDiamondMetalWeight
                      naturalDiamondPurity: $naturalDiamondPurity
                      naturalDiamondMetalValue: $naturalDiamondMetalValue
                      naturalDiamondDiamondType: $naturalDiamondDiamondType
                      naturalDiamondNoOfDiamonds: $naturalDiamondNoOfDiamonds
                      naturalDiamondDiamondCarat: $naturalDiamondDiamondCarat
                      naturalDiamondDiamondPrice: $naturalDiamondDiamondPrice
                      naturalDiamondCertificate: $naturalDiamondCertificate
                      naturalDiamondTotalPrice: $naturalDiamondTotalPrice
                      metalWeight: $metalWeight
                      purity: $purity
                      metalValue: $metalValue
                      diamondType: $diamondType
                      noOfDiamonds: $noOfDiamonds
                      diamondCarat: $diamondCarat
                      diamondPrice: $diamondPrice
                      certificate: $certificate
                      totalPrice: $totalPrice
                      totalSaved: $totalSaved
                      diamondInProductValue: $diamondInProductValue
                      makingCharge: $makingCharge
                      gstPercentage: $gstPercentage
                      gstValue: $gstValue
                      metalPrice: $metalPrice
                      addOnPercentage: $addOnPercentage
                    }
                  }
                ) {
                  diamondComparison {
                    tagNo
                  }
                }
              }
            `,
              variables: { tagNo, ...input }
            });
          }
          console.log("Imported:", tagNo);
        }

        setImporting(false);
        setMessageDialog({ open: true, message: `${jsonData.length} records imported successfully`, type: "success" });
        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        console.error("Import error:", error);
        setImporting(false);
        setMessageDialog({ open: true, message: "Failed to import data", type: "error" });
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
    e.target.value = null;
  };

  const handleAddOpen = () => {
    history.push("/cvd-add");
  };

  const fetchHistoryLogs = async () => {
    setHistoryLoading(true);
    try {
      const res = await fetch(`${API_URL}/cvd/getsynclogs`);
      const json = await res.json();
      setHistoryLogs(json.logs || []);
    } catch (e) { console.error(e); }
    setHistoryLoading(false);
  };

  const handleHistoryOpen = () => {
    setHistoryDialog(true);
    fetchHistoryLogs();
  };

  const handleDownloadHistoryExcel = async (log) => {
    try {
      const res = await fetch(`${API_URL}/cvd/getsynclogdetail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: log.id }),
      });
      const json = await res.json();
      const products = json.log.products || [];
      const headers = ["Tag No","Name","Product Type","Purity","Metal Weight","Metal Cost Price/gm","Metal Selling Price/gm","Metal Price","Diamond Carat","Diamond Price/Ct","Diamond Value","Making Charge","GST%","GST Value","Add On%","CVD Total Price","ND Total Price","Total Saved"];
      const wsData = [headers, ...products.map(r => [
        r.tagNo, r.name, r.productType, r.purity, r.metalWeight, r.metalCostPerGram, r.metalSellingPerGram,
        r.metalPrice, r.diamondCarat, r.diamondPrice, r.diamondInProductValue, r.makingCharge,
        r.gstPercentage, r.gstValue, r.addOnPercentage, r.totalPrice, r.ndTotalPrice, r.totalSaved
      ])];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Price Sync Report");
      const syncedAt = new Date(log.synced_at).toLocaleDateString('en-GB').replace(/\//g, '-');
      XLSX.writeFile(wb, `PriceSync_Report_${syncedAt}_ID${log.id}.xlsx`);
    } catch (e) { console.error(e); }
  };

  const handlePriceSyncOpen = async () => {
    setPriceSyncDialog(true);
    setPriceSyncFilter({ priceMin: "", priceMax: "", purities: [], productTypes: [] });
    try {
      const diamondPrices = data.map(row => row.diamondPrice).filter(Boolean);
      const addOnPercentages = data.map(row => row.addOnPercentage).filter(Boolean);
      const labDiamondPrice = diamondPrices.length > 0 ? diamondPrices[0] : "";
      const addOnPercentage = addOnPercentages.length > 0 ? addOnPercentages[0] : "5";

      // Get distinct product types: product_lists where product_vendor_code IN (tag_no from diamond_comparison)
      const tagNos = data.map(r => r.tagNo).filter(Boolean);
      const productTypeResult = await props.client.query({
        query: gql`
          query($tagNos: [String!]) {
            allProductLists(filter: { productVendorCode: { in: $tagNos } }) {
              nodes {
                productType
                productVendorCode
              }
            }
          }
        `,
        variables: { tagNos },
        fetchPolicy: "network-only",
      });
      const productTypeNodes = productTypeResult.data.allProductLists.nodes;
      // map vendorCode -> productType for filter use
      const vendorProductTypeMap = {};
      productTypeNodes.forEach(n => { if (n.productVendorCode) vendorProductTypeMap[n.productVendorCode] = n.productType; });
      const distinctProductTypes = [...new Set(productTypeNodes.map(n => n.productType).filter(Boolean))];

      // Fetch gold prices for ALL vendors
      const goldResult = await props.client.query({
        query: gql`
          query {
            allGoldPriceSettings(filter: { material: { equalTo: "Gold" } }, first: 500) {
              nodes {
                purity
                costPrice
                sellingPrice
                vendorCode
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      });

      const goldPrices = goldResult.data.allGoldPriceSettings.nodes;
      // Use first vendor's prices as reference values to display in the form
      const getSellingPrice = (purity) => {
        const found = goldPrices.find(g => g.purity === purity);
        return found ? String(found.sellingPrice) : "";
      };
      const getCostPrice = (purity) => {
        const found = goldPrices.find(g => g.purity === purity);
        return found ? String(found.costPrice) : "";
      };
      // Store all unique vendor codes for use in save
      const allVendors = [...new Set(goldPrices.map(g => g.vendorCode).filter(Boolean))];

      setPriceSyncData({
        labDiamondPrice,
        gstPercentage: "3",
        goldPrice24K: getSellingPrice(24),
        goldPrice22K: getSellingPrice(22),
        goldPrice18K: getSellingPrice(18),
        goldPrice14K: getSellingPrice(14),
        goldPrice9K: getSellingPrice(9),
        goldCostPrice24K: getCostPrice(24),
        goldCostPrice22K: getCostPrice(22),
        goldCostPrice18K: getCostPrice(18),
        goldCostPrice14K: getCostPrice(14),
        goldCostPrice9K: getCostPrice(9),
        addOnPercentage,
        allVendors,
        vendorProductTypeMap,
        distinctProductTypes,
      });
    } catch (error) {
      console.error("Error fetching price sync data:", error);
    }
  };

  const GOLD_PURITIES = [22, 18, 14, 9];

  const handleGoldPriceChange = (type, value) => {
    const val = parseFloat(value) || 0;
    const updated = { ...priceSyncData, [type === "cost" ? "goldCostPrice24K" : "goldPrice24K"]: value };
    GOLD_PURITIES.forEach(p => {
      const ratio = p / 24;
      if (type === "cost") {
        updated[`goldCostPrice${p}K`] = val ? String(Math.round(val * ratio * 100) / 100) : "";
      } else {
        updated[`goldPrice${p}K`] = val ? String(Math.round(val * ratio * 100) / 100) : "";
      }
    });
    setPriceSyncData(updated);
  };

  const handlePriceSyncSave = async () => {
    setPriceSyncLoading(true);
    try {
      // Update gold_price_settings for STYPA 090 vendor
      const sellingprices = {
        24: priceSyncData.goldPrice24K,
        22: priceSyncData.goldPrice22K,
        18: priceSyncData.goldPrice18K,
        14: priceSyncData.goldPrice14K,
        9: priceSyncData.goldPrice9K,
      };
      const costprices = {
        24: priceSyncData.goldCostPrice24K,
        22: priceSyncData.goldCostPrice22K,
        18: priceSyncData.goldCostPrice18K,
        14: priceSyncData.goldCostPrice14K,
        9: priceSyncData.goldCostPrice9K,
      };
      // Check if 9K record exists for any vendor, if not create it
      const allVendors = priceSyncData.allVendors || [];
      if (priceSyncData.goldPrice9K) {
        for (const vendor of allVendors) {
          const goldResult = await props.client.query({
            query: gql`query($vendor: String!) { allGoldPriceSettings(condition: { material: "Gold", vendorCode: $vendor, purity: 9 }) { nodes { id } } }`,
            variables: { vendor },
            fetchPolicy: "network-only",
          });
          if (goldResult.data.allGoldPriceSettings.nodes.length === 0) {
            await fetch(`${API_URL}/updatemetalprice`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                material: "Gold",
                purity: 9,
                vendor,
                isadd: true,
                costprice: priceSyncData.goldCostPrice9K,
                sellingprice: priceSyncData.goldPrice9K,
                pricetype: 1,
              }),
            });
          }
        }
      }
      await fetch(`${API_URL}/updatevendorgoldprice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          costprices: costprices,
          sellingprices: sellingprices,
          vendors: allVendors,
          metal: { name: "Gold", shortCode: "G" },
          pricetype: { label: "Flat", value: 1 },
        }),
      });

      // Update diamond_comparison records with calculated values
      const goldSellingPriceMap = {
        "24": parseFloat(priceSyncData.goldPrice24K) || 0,
        "22": parseFloat(priceSyncData.goldPrice22K) || 0,
        "18": parseFloat(priceSyncData.goldPrice18K) || 0,
        "14": parseFloat(priceSyncData.goldPrice14K) || 0,
        "9": parseFloat(priceSyncData.goldPrice9K) || 0,
      };
      const goldCostPriceMap = {
        "24": parseFloat(priceSyncData.goldCostPrice24K) || 0,
        "22": parseFloat(priceSyncData.goldCostPrice22K) || 0,
        "18": parseFloat(priceSyncData.goldCostPrice18K) || 0,
        "14": parseFloat(priceSyncData.goldCostPrice14K) || 0,
        "9": parseFloat(priceSyncData.goldCostPrice9K) || 0,
      };
      const reportRows = [];
      for (const row of data.filter(row => {
        const price = parseFloat(row.totalPrice) || 0;
        const minOk = priceSyncFilter.priceMin === "" || price >= parseFloat(priceSyncFilter.priceMin);
        const maxOk = priceSyncFilter.priceMax === "" || price <= parseFloat(priceSyncFilter.priceMax);
        const purityOk = priceSyncFilter.purities.length === 0 || priceSyncFilter.purities.includes(String(row.purity || "").replace(/K/i, ""));
        const productType = (priceSyncData.vendorProductTypeMap || {})[row.tagNo] || "";
        const typeOk = priceSyncFilter.productTypes.length === 0 || priceSyncFilter.productTypes.includes(productType);
        return minOk && maxOk && purityOk && typeOk;
      })) {
        const diamondCarat = parseFloat(row.diamondCarat) || 0;
        const diamondPrice = parseFloat(priceSyncData.labDiamondPrice) || 0;
        const metalWeight = parseFloat(row.metalWeight) || 0;
        const makingCharge = parseFloat(row.makingCharge) || 0;
        const gstPercentage = parseFloat(priceSyncData.gstPercentage) || 0;
        const ndTotalPrice = parseFloat(row.naturalDiamondTotalPrice) || 0;

        // Get gold price per gram based on product's purity
        const purityNum = String(row.purity).replace(/K/i, "");
        const metalValue = Math.round(goldSellingPriceMap[purityNum] || 0);
        const metalCostValue = Math.round(goldCostPriceMap[purityNum] || 0);

        const addOnPercentage = parseFloat(priceSyncData.addOnPercentage) || 0;
        const diamondInProductValue = Math.round(diamondCarat * diamondPrice);
        const metalPriceCalc = Math.round(metalValue * metalWeight);
        const gstValue = Math.round((gstPercentage / 100) * (diamondInProductValue + makingCharge + metalPriceCalc));
        const totalPrice = Math.round((diamondInProductValue + makingCharge + metalPriceCalc + gstValue) * (1 + addOnPercentage / 100));
        const totalSaved = Math.round(ndTotalPrice - totalPrice);

        // discount_price uses cost_price of metal
        const metalPriceCost = Math.round(metalCostValue * metalWeight);
        const gstValueCost = Math.round((gstPercentage / 100) * (diamondInProductValue + makingCharge + metalPriceCost));
        const discountPrice = Math.round((diamondInProductValue + makingCharge + metalPriceCost + gstValueCost) * (1 + addOnPercentage / 100));

        await props.client.mutate({
          mutation: UPDATE_CVD,
          variables: {
            tagNo: row.tagNo,
            input: {
              diamondPrice: String(diamondPrice),
              gstPercentage: priceSyncData.gstPercentage,
              addOnPercentage: priceSyncData.addOnPercentage,
              metalValue: String(metalValue),
              diamondInProductValue: String(diamondInProductValue),
              metalPrice: String(metalPriceCalc),
              gstValue: String(gstValue),
              totalPrice: String(totalPrice),
              totalSaved: String(totalSaved),
            },
          },
        });

        // Update trans_sku_lists markup_price and discount_price
        await fetch(`${API_URL}/updatecvdskuprice`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productId: row.tagNo, totalPrice: totalPrice, discountPrice: discountPrice }),
        });

        reportRows.push({
          tagNo: row.tagNo,
          name: row.name || "",
          productType: (priceSyncData.vendorProductTypeMap || {})[row.tagNo] || "",
          purity: row.purity || "",
          metalWeight: metalWeight,
          metalCostPerGram: metalCostValue,
          metalSellingPerGram: metalValue,
          metalPrice: metalPriceCalc,
          diamondCarat: diamondCarat,
          diamondPrice: diamondPrice,
          diamondInProductValue: diamondInProductValue,
          makingCharge: makingCharge,
          gstPercentage: gstPercentage,
          gstValue: gstValue,
          addOnPercentage: addOnPercentage,
          totalPrice: totalPrice,
          ndTotalPrice: ndTotalPrice,
          totalSaved: totalSaved,
        });
      }

      if (reportRows.length > 0) {
        const now = new Date();
        const dateStr = now.toLocaleDateString('en-GB').replace(/\//g, '-');
        const timeStr = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-');
        const headers = ["Tag No","Name","Product Type","Purity","Metal Weight","Metal Cost Price/gm","Metal Selling Price/gm","Metal Price","Diamond Carat","Diamond Price/Ct","Diamond Value","Making Charge","GST%","GST Value","Add On%","CVD Total Price","ND Total Price","Total Saved"];
        const wsData = [headers, ...reportRows.map(r => [
          r.tagNo, r.name, r.productType, r.purity, r.metalWeight, r.metalCostPerGram, r.metalSellingPerGram, r.metalPrice,
          r.diamondCarat, r.diamondPrice, r.diamondInProductValue, r.makingCharge,
          r.gstPercentage, r.gstValue, r.addOnPercentage, r.totalPrice, r.ndTotalPrice, r.totalSaved
        ])];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Price Sync Report");
        XLSX.writeFile(wb, `PriceSync_Report_${dateStr}_${timeStr}.xlsx`);
      }

      // Save sync log to DB
      await fetch(`${API_URL}/cvd/savesynclog`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filters: priceSyncFilter,
          goldPrices: {
            cost: { 24: priceSyncData.goldCostPrice24K, 22: priceSyncData.goldCostPrice22K, 18: priceSyncData.goldCostPrice18K, 14: priceSyncData.goldCostPrice14K, 9: priceSyncData.goldCostPrice9K },
            selling: { 24: priceSyncData.goldPrice24K, 22: priceSyncData.goldPrice22K, 18: priceSyncData.goldPrice18K, 14: priceSyncData.goldPrice14K, 9: priceSyncData.goldPrice9K },
          },
          labDiamondPrice: priceSyncData.labDiamondPrice,
          gstPercentage: priceSyncData.gstPercentage,
          addOnPercentage: priceSyncData.addOnPercentage,
          products: reportRows,
        }),
      });

      setPriceSyncLoading(false);
      setPriceSyncDialog(false);
      setMessageDialog({ open: true, message: "Price sync updated successfully", type: "success" });
      fetchData();
    } catch (error) {
      console.error("Error updating price sync:", error);
      setPriceSyncLoading(false);
      setMessageDialog({ open: true, message: "Failed to update price sync", type: "error" });
    }
  };

  const handleAddClose = () => {
    setAddDialog(false);
    setAddData({});
  };

  const handleAddProductSelect = async (event, value) => {
    if (value) {
      setAddData({ ...addData, tagNo: value.productId, name: value.productName });
      try {
        const result = await props.client.query({
          query: CVD_PRODUCT_DETAILS,
          variables: { productId: value.productId },
          fetchPolicy: "network-only",
        });
        const product = result.data.productListByProductId;
        if (product) {
          const sku = product.transSkuListsByProductId?.nodes?.[0];
          const diamonds = product.productDiamondsByProductSku?.nodes || [];
          const totalStoneCount = diamonds.reduce((sum, d) => sum + (parseInt(d.stoneCount) || 0), 0);
          const totalStoneWeight = diamonds.reduce((sum, d) => sum + (parseFloat(d.stoneWeight) || 0), 0);
          const diamondType = sku?.diamondType || diamonds[0]?.diamondType || "";
          setAddData({
            ...addData,
            tagNo: value.productId,
            name: value.productName,
            metalWeight: sku?.skuWeight ? String(sku.skuWeight) : "",
            purity: sku?.purity ? String(sku.purity) : "",
            metalValue: sku?.markupPrice ? String(sku.markupPrice) : "",
            diamondType: diamondType ? String(diamondType) : "",
            noOfDiamonds: totalStoneCount ? String(totalStoneCount) : "",
            diamondCarat: totalStoneWeight ? String(totalStoneWeight) : "",
            diamondPrice: sku?.sellingPrice ? String(sku.sellingPrice) : "",
          });
        }
      } catch (error) {
        console.error("Error fetching CVD product details:", error);
      }
    } else {
      setAddData({ ...addData, tagNo: "", name: "" });
    }
  };

  const handleAddChange = (field, value) => {
    setAddData({ ...addData, [field]: value });
  };

  const handleAddSave = async () => {
    if (!addData.tagNo) {
      setMessageDialog({ open: true, message: "Please select a CVD product", type: "error" });
      return;
    }
    const exists = data.some(row => row.tagNo === addData.tagNo);
    if (exists) {
      setMessageDialog({ open: true, message: "Tag No already exists in comparison list", type: "error" });
      return;
    }
    try {
      const { tagNo, ...input } = addData;
      await props.client.mutate({
        mutation: gql`
          mutation CreateDiamondComparison(
            $tagNo: String!
            $name: String
            $naturalDiamondMetalWeight: String
            $naturalDiamondPurity: String
            $naturalDiamondMetalValue: String
            $naturalDiamondDiamondType: String
            $naturalDiamondNoOfDiamonds: String
            $naturalDiamondDiamondCarat: String
            $naturalDiamondDiamondPrice: String
            $naturalDiamondCertificate: String
            $naturalDiamondTotalPrice: String
            $metalWeight: String
            $purity: String
            $metalValue: String
            $diamondType: String
            $noOfDiamonds: String
            $diamondCarat: String
            $diamondPrice: String
            $certificate: String
            $totalPrice: String
            $totalSaved: String
            $diamondInProductValue: String
            $makingCharge: String
            $gstPercentage: String
            $gstValue: String
            $metalPrice: String
            $addOnPercentage: String
          ) {
            createDiamondComparison(
              input: {
                diamondComparison: {
                  tagNo: $tagNo
                  name: $name
                  naturalDiamondMetalWeight: $naturalDiamondMetalWeight
                  naturalDiamondPurity: $naturalDiamondPurity
                  naturalDiamondMetalValue: $naturalDiamondMetalValue
                  naturalDiamondDiamondType: $naturalDiamondDiamondType
                  naturalDiamondNoOfDiamonds: $naturalDiamondNoOfDiamonds
                  naturalDiamondDiamondCarat: $naturalDiamondDiamondCarat
                  naturalDiamondDiamondPrice: $naturalDiamondDiamondPrice
                  naturalDiamondCertificate: $naturalDiamondCertificate
                  naturalDiamondTotalPrice: $naturalDiamondTotalPrice
                  metalWeight: $metalWeight
                  purity: $purity
                  metalValue: $metalValue
                  diamondType: $diamondType
                  noOfDiamonds: $noOfDiamonds
                  diamondCarat: $diamondCarat
                  diamondPrice: $diamondPrice
                  certificate: $certificate
                  totalPrice: $totalPrice
                  totalSaved: $totalSaved
                  diamondInProductValue: $diamondInProductValue
                  makingCharge: $makingCharge
                  gstPercentage: $gstPercentage
                  gstValue: $gstValue
                  metalPrice: $metalPrice
                  addOnPercentage: $addOnPercentage
                }
              }
            ) {
              diamondComparison { tagNo }
            }
          }
        `,
        variables: { tagNo, ...input }
      });
      setAddDialog(false);
      setAddData({});
      setMessageDialog({ open: true, message: "Record added successfully", type: "success" });
      fetchData();
    } catch (error) {
      console.error("Error adding CVD record:", error);
      setMessageDialog({ open: true, message: "Failed to add record", type: "error" });
    }
  };

  const handleExport = () => {
    const now = new Date();
    const date = now.toLocaleDateString('en-GB').replace(/\//g, '-');
    const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-');
    
    const wsData = [columns.map(col => col.label)];
    filteredData.forEach(row => {
      wsData.push(columns.map(col => row[col.key] !== null && row[col.key] !== undefined ? row[col.key] : ""));
    });
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CVD");
    XLSX.writeFile(wb, `CVD_${date}_${time}.xlsx`);
  };

  return (
    <Paper>
      <Grid container spacing={2} alignItems="center" className={classes.search}>
        <Grid item>
          <TextField
            placeholder="Tag No"
            variant="outlined"
            size="small"
            className={classes.searchField}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleAddOpen}>
            ADD
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" component="label" disabled={importing}>
            {importing ? "IMPORTING..." : "IMPORT"}
            <input type="file" hidden accept=".xlsx,.xls,.csv" onChange={handleImport} />
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleExport}>
            EXPORT
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleColumnsClick}>
            COLUMNS
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleColumnsClose}
          >
            {columns.map((col) => (
              <MenuItem key={col.key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={visibleColumns[col.key]}
                      onChange={() => handleColumnToggle(col.key)}
                    />
                  }
                  label={col.label}
                />
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={() => history.push("/goldpriceupdate")}>
            METAL PRICE
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={handlePriceSyncOpen}>
            PRICE SYNC
          </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="primary" onClick={handleHistoryOpen}>
              SYNC HISTORY
            </Button>
          </Grid>
      </Grid>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
          <TableRow>
            {columns.map((col) => (
              visibleColumns[col.key] && (
                <TableCell key={col.key} style={col.key === "tagNo" ? { minWidth: "200px", whiteSpace: "nowrap" } : {}}>
                  <TableSortLabel
                    active={orderBy === col.key}
                    direction={orderBy === col.key ? order : "asc"}
                    onClick={() => handleSort(col.key)}
                  >
                    {col.label}
                  </TableSortLabel>
                </TableCell>
              )
            ))}
            <TableCell style={{ minWidth: "150px", whiteSpace: "nowrap" }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
            <TableRow key={row.tagNo} className={classes.tableRow}>
              {columns.map((col) => (
                visibleColumns[col.key] && (
                  <TableCell key={col.key} style={col.key === "tagNo" ? { minWidth: "200px", whiteSpace: "nowrap" } : {}}>
                    {editingRow === row.tagNo ? (
                      <TextField
                        size="small"
                        fullWidth
                        value={editData[col.key] || ""}
                        onChange={(e) => handleEditChange(col.key, e.target.value)}
                      />
                    ) : (
                      row[col.key]
                    )}
                  </TableCell>
                )
              ))}
              <TableCell style={{ minWidth: "150px", whiteSpace: "nowrap" }}>
                {editingRow === row.tagNo ? (
                  <>
                    <IconButton size="small" color="primary" onClick={handleSaveEdit}>
                      <SaveIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={handleCancelEdit}>
                      <CancelIcon fontSize="small" />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <Tooltip title="View">
                      <IconButton size="small" style={{ color: "#4caf50" }} onClick={() => history.push(`/cvd-detail/${row.tagNo}/view`)}>
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton size="small" style={{ color: "#1976d2" }} onClick={() => history.push(`/cvd-detail/${row.tagNo}/edit`)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Image">
                      <IconButton size="small" style={{ color: "#ff9800" }} onClick={() => handleImageClick(row)}>
                        <AddPhotoAlternateIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" style={{ color: "#f44336" }} onClick={() => handleDeleteClick(row.tagNo)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
    <Dialog open={deleteDialog} onClose={handleDeleteCancel}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete record with Tag No: {deleteTagNo}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteCancel} color="default">
          Cancel
        </Button>
        <Button onClick={handleDeleteConfirm} color="secondary" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={messageDialog.open} onClose={() => setMessageDialog({ open: false, message: "", type: "" })}>
      <DialogTitle>{messageDialog.type === "success" ? "Success" : "Error"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{messageDialog.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setMessageDialog({ open: false, message: "", type: "" })} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={imageDialog.open} onClose={handleImageClose} maxWidth="md" fullWidth>
      <DialogTitle>Manage Images for {imageDialog.tagNo}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Image 1</Typography>
            {imageDialog.images?.image1 ? (
              <div style={{ position: "relative", width: "200px", height: "200px" }}>
                <img
                  src={`${CVD_URL}${imageDialog.images.image1}`}
                  alt="Image 1"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            ) : null}
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <Button variant="outlined" component="label" color="primary">
                {imageDialog.images?.image1 ? "Edit Image 1" : "Upload Image 1"}
                <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e, 1)} />
              </Button>
              {imageDialog.images?.image1 && (
                <Button variant="outlined" onClick={() => handleImageDeleteClick(1)} style={{ color: "red", borderColor: "red" }}>
                  Delete
                </Button>
              )}
            </div>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">Image 2</Typography>
            {imageDialog.images?.image2 ? (
              <div style={{ position: "relative", width: "200px", height: "200px" }}>
                <img
                  src={`${CVD_URL}${imageDialog.images.image2}`}
                  alt="Image 2"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            ) : null}
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <Button variant="outlined" component="label" color="primary">
                {imageDialog.images?.image2 ? "Edit Image 2" : "Upload Image 2"}
                <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e, 2)} />
              </Button>
              {imageDialog.images?.image2 && (
                <Button variant="outlined" onClick={() => handleImageDeleteClick(2)} style={{ color: "red", borderColor: "red" }}>
                  Delete
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleImageClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={imageDeleteDialog.open} onClose={handleImageDeleteCancel}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete Image {imageDeleteDialog.imageNumber}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleImageDeleteCancel} color="default">
          Cancel
        </Button>
        <Button onClick={handleImageDeleteConfirm} style={{ color: "red" }}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={addDialog} onClose={handleAddClose} maxWidth="md" fullWidth>
      <DialogTitle>Add CVD Diamond Comparison</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={cvdProducts.filter(p => !data.some(d => d.tagNo === p.productVendorCode || d.tagNo === p.productId))}
              getOptionLabel={(option) => `${option.productId} - ${option.productName}`}
              onChange={handleAddProductSelect}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select CVD Product (Lab Grown Diamond)"
                  variant="outlined"
                  size="small"
                  margin="dense"
                  required
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Tag No" variant="outlined" size="small" fullWidth margin="dense" disabled value={addData.tagNo || ""} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Name" variant="outlined" size="small" fullWidth margin="dense" disabled value={addData.name || ""} />
          </Grid>
          {columns.filter(col => col.key !== "tagNo" && col.key !== "name").map((col) => {
            const autoPopulatedFields = ["metalWeight", "purity", "metalValue", "diamondType", "noOfDiamonds", "diamondCarat", "diamondPrice"];
            const isAutoPopulated = autoPopulatedFields.includes(col.key) && addData.tagNo && addData[col.key];
            return (
              <Grid item xs={6} key={col.key}>
                <TextField
                  label={col.label}
                  variant="outlined"
                  size="small"
                  fullWidth
                  margin="dense"
                  value={addData[col.key] || ""}
                  onChange={(e) => handleAddChange(col.key, e.target.value)}
                  InputProps={{ readOnly: !!isAutoPopulated }}
                />
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddClose} color="default">Cancel</Button>
        <Button onClick={handleAddSave} color="primary" variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
    <Dialog open={priceSyncLoading}>
      <DialogContent style={{ display: "flex", alignItems: "center", gap: 16, padding: 24 }}>
        <CircularProgress size={24} />
        <Typography>Syncing prices... Please wait.</Typography>
      </DialogContent>
    </Dialog>
    <Dialog open={priceSyncDialog} onClose={() => setPriceSyncDialog(false)} maxWidth="md" fullWidth>
      <DialogTitle>Price Sync</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#1976d2" }}>Filter (apply changes only to matching products)</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Min Price"
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              type="number"
              value={priceSyncFilter.priceMin}
              onChange={(e) => setPriceSyncFilter({ ...priceSyncFilter, priceMin: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Max Price"
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              type="number"
              value={priceSyncFilter.priceMax}
              onChange={(e) => setPriceSyncFilter({ ...priceSyncFilter, priceMax: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={[...new Set(data.map(r => String(r.purity || "").replace(/K/i, "")).filter(Boolean))]}
              value={priceSyncFilter.purities}
              onChange={(e, val) => setPriceSyncFilter({ ...priceSyncFilter, purities: val })}
              getOptionLabel={(option) => option + "K"}
              getOptionSelected={(option, value) => option === value}
              renderInput={(params) => <TextField {...params} label="Metal Purity" variant="outlined" size="small" margin="dense" />}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={priceSyncData.distinctProductTypes || []}
              value={priceSyncFilter.productTypes}
              onChange={(e, val) => setPriceSyncFilter({ ...priceSyncFilter, productTypes: val })}
              getOptionLabel={(option) => option}
              getOptionSelected={(option, value) => option === value}
              renderInput={(params) => <TextField {...params} label="Product Type" variant="outlined" size="small" margin="dense" />}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" style={{ color: "#666" }}>
              {(() => {
                const filtered = data.filter(row => {
                  const price = parseFloat(row.totalPrice) || 0;
                  const minOk = priceSyncFilter.priceMin === "" || price >= parseFloat(priceSyncFilter.priceMin);
                  const maxOk = priceSyncFilter.priceMax === "" || price <= parseFloat(priceSyncFilter.priceMax);
                  const purityOk = priceSyncFilter.purities.length === 0 || priceSyncFilter.purities.includes(String(row.purity || "").replace(/K/i, ""));
                  const productType = (priceSyncData.vendorProductTypeMap || {})[row.tagNo] || "";
                  const typeOk = priceSyncFilter.productTypes.length === 0 || priceSyncFilter.productTypes.includes(productType);
                  return minOk && maxOk && purityOk && typeOk;
                });
                return `${filtered.length} of ${data.length} products will be updated`;
              })()}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Lab Diamond Price (per carat)"
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.labDiamondPrice}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, labDiamondPrice: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="GST %"
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.gstPercentage}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, gstPercentage: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Add On %"
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.addOnPercentage}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, addOnPercentage: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", marginTop: 8 }}>Gold Price (per gram)</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" style={{ fontWeight: "bold" }}>Purity</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" style={{ fontWeight: "bold" }}>Cost Price</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" style={{ fontWeight: "bold" }}>Selling Price</Typography>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">24K</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldCostPrice24K}
              onChange={(e) => handleGoldPriceChange("cost", e.target.value)}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldPrice24K}
              onChange={(e) => handleGoldPriceChange("selling", e.target.value)}
            />
          </Grid>
          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">22K</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldCostPrice22K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldCostPrice22K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldPrice22K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldPrice22K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">18K</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldCostPrice18K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldCostPrice18K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldPrice18K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldPrice18K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">14K</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldCostPrice14K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldCostPrice14K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldPrice14K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldPrice14K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2">9K</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldCostPrice9K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldCostPrice9K: e.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              value={priceSyncData.goldPrice9K}
              onChange={(e) => setPriceSyncData({ ...priceSyncData, goldPrice9K: e.target.value })}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPriceSyncDialog(false)} color="default">Close</Button>
        <Button onClick={handlePriceSyncSave} color="primary" variant="contained">Save</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={historyDialog} onClose={() => setHistoryDialog(false)} maxWidth="md" fullWidth>
      <DialogTitle>Sync History</DialogTitle>
      <DialogContent>
        {historyLoading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
            <CircularProgress />
          </div>
        ) : historyLogs.length === 0 ? (
          <DialogContentText>No sync history found.</DialogContentText>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Synced At</TableCell>
                <TableCell>Diamond Price</TableCell>
                <TableCell>GST%</TableCell>
                <TableCell>Add On%</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historyLogs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{log.id}</TableCell>
                  <TableCell>{new Date(log.synced_at).toLocaleString('en-GB')}</TableCell>
                  <TableCell>{log.lab_diamond_price}</TableCell>
                  <TableCell>{log.gst_percentage}</TableCell>
                  <TableCell>{log.add_on_percentage}</TableCell>
                  <TableCell>
                    <Button size="small" variant="outlined" color="primary" onClick={() => handleDownloadHistoryExcel(log)}>
                      Excel
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setHistoryDialog(false)} color="primary">Close</Button>
      </DialogActions>
    </Dialog>

    </Paper>
  );
});

